import Vue from 'vue'
import Component from 'vue-class-component'

import { Course, CourseSection, VueFire } from '@codee-club/common/dist/dao'
import { entries } from '@codee-club/common/dist/utils/object-extensions'

import Routes from '@/router/routes'

@Component
export default class CourseJoin extends Vue {
  get course(): VueFire<Course> | undefined {
    // Search in both myCourses and openCourses
    const course = this.$store.state.myCourses.find((c: VueFire<Course>) => c.slug === this.$route.params.courseSlug)
    if (course !== undefined) return course
    return this.$store.state.openCourses.find((c: VueFire<Course>) => c.slug === this.$route.params.courseSlug)
  }

  get sections(): Array<[string, CourseSection]> {
    if (!this.course?.sections) return []
    return entries(this.course.sections).sort(([, a], [, b]) => a.code.localeCompare(b.code))
  }

  async join(sectionId: string): Promise<void> {
    if (!this.course) return
    const userId = this.$store.state.currentUser.id
    const courseId = this.course.id

    try {
      await this.$dao.joinCourseSection(userId, courseId, sectionId)
      this.$buefy.toast.open({
        message: `Joined course ${this.course.name} successfully!`,
        type: 'is-success'
      })
      await this.$router.push({ name: Routes.StudentCourseView, params: { courseSlug: this.course.slug } })
    } catch (error) {
      console.error(error)
      this.$buefy.toast.open({
        message: 'Failed to join course. Please try again.',
        type: 'is-danger'
      })
    }
  }
}
